module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_1@3x.3cc0c68f.png";